import { render, staticRenderFns } from "./TableFieldsConfigurator.vue?vue&type=template&id=f873b302&"
import script from "./TableFieldsConfigurator.vue?vue&type=script&lang=js&"
export * from "./TableFieldsConfigurator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports